import InputQuantity from './input-quantity-view'

export default InputQuantity
